import { ResourceFilters } from './types';

export const DEFAULT_FILTERS: ResourceFilters = {
  qualified: true,
  available: true,
  onSchedule: false,
};

export const chipClass = (active: boolean) =>
  active
    ? 'border-primary-100 bg-primary-50 font-semibold text-primary-600'
    : 'border-neutral-50 bg-neutral-50 text-neutral-500';
